import React, { useMemo, useState } from "react";

// project-imports
import { EBOOK, INTERNSHIP } from "../../constants";
import { formatDateWithSuffixV2, formatINR } from "../../utils";
import { useOrderContext } from "../../context/order_context";
import ModalLogin from "../form/ModalLogin";
import { PaymentSuccessModel } from "../success-model/PaymentSuccessModel";
import { OrderDetails } from "./OrderDetails";
import { PAISE } from "../../constants/entityType";
import { FaCheckDouble, FaRegHourglassHalf } from "react-icons/fa6";
import { FaDownload } from "react-icons/fa";

// Reading env variable
const VENDOR_NAME = process.env.REACT_APP_RAZOR_APP_VENDOR_NAME;
const RAZOR_THEME = process.env.REACT_APP_RAZOR_APP_THEME_COLOR;

const OrderTable = ({ orders = [], member, error }) => {

    const { downloadEbook, orderLoading } = useOrderContext();

    // State initialization
    const [showDetails, setShowDetails] = useState(false);
    const [notLoggedIn, setNotLoggedIn] = useState(false);
    const [paymentSucess, setPaymentSucess] = useState(false);
    const [newOrder, setNewOrder] = useState({});
    const [selectedOrder, setSelectedOrder] = useState(null);

    // Handle function for Pay Now
    const handlePayNow = async (order) => {
        try {
            if (!member || (member && !member?.userId)) {
                setNotLoggedIn(true);
                return
            }
            // Addded this
            if (!error) {
                const options = {
                    // key: "rzp_test_Rigzt2dMfwegb3",   // Only key_id is safe to expose
                    key: process.env.REACT_APP_RAZOR_APP_KEY,
                    orderId: order?.razorPayOrderId,
                    amount: order?.amount,                 // Amount in paise → Rs 500
                    currency: order?.orderCurrency,
                    name: order?.vendorName,
                    description: order?.notes[0]?.description,
                    image: process.env.REACT_APP_LOGO_URL,
                    handler: function (response) {
                        alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
                        setNewOrder({ ...order, paymentId: response.razorpay_payment_id });
                        (order?.notes[0]?.type === "ebook" && !(order && order?.receipt && order?.receipt?.includes("free")) ? order : {}) && downloadEbook({ paymentId: response?.razorpay_payment_id, productId: order?.notes[0]?.productCode, productName: order?.notes[0]?.name, entityType: "free" });
                        setPaymentSucess(true);
                        // 
                    },
                    prefill: {
                        name: order?.customer?.fullName,
                        email: order?.customer?.userId,
                        contact: "",
                    },
                    theme: {
                        color: RAZOR_THEME,
                    },
                    notify: {
                        "sms": true,
                        "email": true
                    },
                    notes: {
                        "item_description": order?.notes[0]?.description// You can add item details here as well
                    }
                };

                const rzp = new window.Razorpay(options);
                rzp.open();
            }
        } catch (error) {
            console.log("75 : OrderTable : Error in handleInfoBtnClick function : ", error && JSON.stringify(error));
        }
    };

    const isPaymentDone = () => {
        if (newOrder && Object.keys(newOrder).length && newOrder.paymentId && paymentSucess) {
            return true;
        }
    }

    const showDetailsModal = (order) => {
        try {
            setSelectedOrder(order)
            setShowDetails(true);
        } catch (error) {
            console.log("90 : OrderTable : Error in handle showDetailsModal", error);
        }
    };
    const hideDetailsModal = () => setShowDetails(false);

    const closeModalLogin = () => setNotLoggedIn(false);
    const closeModalPaymentSuccess = () => setPaymentSucess(false);

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case "authorized":
                return "color-success";

            case "created":
                return "color-secondary";

            default:
                return "text-dark";
        }
    };

    return (
        <div>
            <div className="table-responsive">
                <table className="table table-bordered custom-stack-table">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th className="text-start">Product Name</th>
                            <th>Date</th>
                            <th className="text-end">Amount</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th className="text-center">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders && orders?.length > 0 ?
                            <>
                                {(orders || [])?.map((order, index) => (
                                    <>
                                        <tr key={order.id} className="fs-15">
                                            <td data-label="No.">
                                                {index + 1}
                                            </td>

                                            <td data-label="Product Name" className="text-end text-sm-start">
                                                <span className="color-heading fw-semibold">
                                                    {order?.notes[0]?.name || ""}
                                                </span>
                                            </td>
                                            <td data-label="Date" className="color-body">{formatDateWithSuffixV2(order?.createdAt)}</td>
                                            <td data-label="Amount" className="text-end">
                                                <span className="color-heading fw-semibold">
                                                    {order?.amountUnit === PAISE ? formatINR((order?.amount / 100), true) : order?.amount || 0}
                                                </span>
                                            </td>
                                            <td data-label="Type" className="color-body">{order?.notes[0].type === "ebook" ? EBOOK : INTERNSHIP}</td>
                                            <td data-label="Status">
                                                <span
                                                    className={`fw-semibold ${getStatusClass(
                                                        order?.status
                                                    )}`}
                                                >
                                                    {order?.status === "authorized" ? <FaCheckDouble /> : (order && order?.receipt && order?.receipt?.includes("free")) ? <FaDownload /> : <FaRegHourglassHalf />}

                                                    <span className="ml--5">{order?.status === "created" ? "Pending" : order && order?.status && order?.status === "authorized" ? "Paid" : (order?.status || "")}</span>
                                                </span>
                                            </td>
                                            <td data-label="Action">
                                                {order?.status?.toLowerCase() ===
                                                    "created" ? (
                                                    <button
                                                        type="button"
                                                        className="edu-btn btn-xl-small btn-primary w-auto bg-color-primary text-white"
                                                        onClick={() =>
                                                            handlePayNow(order)
                                                        }
                                                    >
                                                        {/* <i className="bi bi-credit-card me-1"></i> */}
                                                        Pay Now
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="edu-btn btn btn-xl-small w-auto btn-dark text-white"
                                                        onClick={() => showDetailsModal(order)}
                                                    >
                                                        {/* <i className="bi bi-check2 me-1"></i> */}
                                                        {order?.status === "authorized" ? "View" : ""}
                                                    </button>

                                                )}
                                            </td>
                                        </tr>
                                        <OrderDetails show={showDetails} onCloseModal={hideDetailsModal} title={"Order Details"} data={selectedOrder && selectedOrder?.receipt && selectedOrder?.receipt?.includes("free") ? { ...selectedOrder, amount: 0.00 } : selectedOrder} userDetail={member} isOrderFree={selectedOrder && selectedOrder?.receipt && selectedOrder?.receipt?.includes("free")} />
                                        <ModalLogin show={notLoggedIn} onCloseModalLogin={closeModalLogin} title={'Login to proceed payment'} />
                                        {isPaymentDone() && <PaymentSuccessModel show={paymentSucess} onCloseModal={closeModalPaymentSuccess} amount={order?.amountUnit === PAISE ? (order?.amount) / 100 : order?.amount} orderId={order?.razorPayOrderId} />}
                                    </>
                                ))}
                            </>
                            :
                            <>
                                <tr className="no-data-row">
                                    <td colSpan="7" className="text-center py-4">
                                        No data found
                                    </td>
                                </tr>
                            </>
                        }
                    </tbody>
                </table>
            </div>



        </div>
    );
};

export default OrderTable;